import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { NgIf } from '@angular/common';
import { TooltipOptions } from 'primeng/api';
import { FONT_AWESOME_ICONS } from '@shared/icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PortalTheme } from '@app/@shared/models';
import { CssValidatorService } from '@app/@shared/services/css-validator.service';

@Component({
  selector: 'app-offer-details-header-buttons',
  templateUrl: './offer-details-header-buttons.component.html',
  styleUrls: ['./offer-details-header-buttons.component.scss'],
  standalone: true,
  imports: [NgIf, ButtonModule, TooltipModule, FaIconComponent],
})
export class OfferDetailsHeaderButtonsComponent implements OnInit {
  private readonly cssValidatorService = inject(CssValidatorService);
  @Input() isPendingTextNotSent = false;
  @Input() public theme: PortalTheme | undefined;
  @Output() duplicateOfferEvent = new EventEmitter(false);
  @Output() editOfferEvent = new EventEmitter(false);

  protected tooltipOptions: TooltipOptions = {
    tooltipPosition: 'top',
  };

  protected icons = FONT_AWESOME_ICONS;

  protected duplicateOffer() {
    this.duplicateOfferEvent.emit(true);
  }

  protected editOffer() {
    this.editOfferEvent.emit(true);
  }

  ngOnInit(): void {
    this.setCSSCustomProperties();
  }

  private setCSSCustomProperties(): void {
    if (this.theme) {
      // Set CSS custom properties
      document.documentElement.style.setProperty('--primary', this.theme.primary);
      // Check for undefined CSS variables
      this.cssValidatorService.checkUndefinedCssVariables('OfferDetailsHeaderButtonsComponent');
    }
  }
}
